const UrlParser = require("./url_parser").UrlParser;

module.exports = {
  UrlParser
};
